import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';

import { HttpService } from '../service/http.service';
import { SchoolInvoiceListItem } from '../school-invoice-list-item';
import { Table } from 'primeng/table';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-transactions-school-invoice',
  templateUrl: './transactions-school-invoice.component.html',
  styleUrls: ['./transactions-school-invoice.component.css']
})
export class TransactionsSchoolInvoiceComponent implements OnInit {

  @ViewChild('dataTable') table!: Table;
  @ViewChild("idInput") idInput!: ElementRef;
  @ViewChild("studentNameInput") studentNameInput!: ElementRef;
  @ViewChild("invoiceNumberInput") invoiceNumberInput!: ElementRef;
  @ViewChild("commentInput") commentInput!: ElementRef;
  @ViewChild("amountInput") amountInput!: ElementRef;
  @ViewChild("schoolNameInput") schoolNameInput!: ElementRef;

  years: SelectItem[] = [];
  invoices: SchoolInvoiceListItem[] = [];
  currencyIsoCodes: SelectItem[] = [];
  selectedCurrencyIsoCodes: string[] = [];
  withElb: boolean = false;
  isActive: boolean = true;

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
    let thisYear = moment().year();
    for (let i = 0; i < 5; i++) {
      let oldYear = thisYear - i;
      this.years.push({ label: oldYear.toString(), value: oldYear });
    }
    this.httpService.getCurrencies().subscribe(res => {
      this.currencyIsoCodes = [];
      for (let currency of res) {
        this.currencyIsoCodes.push({ label: currency.isoCode, value: currency.isoCode });
      }
    });
    this.refreshData(thisYear);
  }

  changeYear(value: number) {
    this.refreshData(value);
  }

  elbChange(){
    console.log(this.withElb);
  }

  refreshData(year: number) {
    this.httpService.getSchoolInvoiceListItemsByYear(year).subscribe(res => {
      this.invoices = res;
    });
  }

  onInvoiceDateSelect(value: Date) {
    this.table.filter(moment(value).format("YYYY-MM-DD"), 'invoiceDate', 'equals');
  }

  onStartDateSelect(value: Date) {
    this.table.filter(moment(value).format("YYYY-MM-DD"), 'startDate', 'equals');
  }

  downloadInvoice(invoice: SchoolInvoiceListItem) {
    this.httpService.getSchoolInvoiceFileById(invoice.fileId).subscribe(res => {
      let binaryData: BlobPart[] = [];
      binaryData.push(res);
      this.downloadFile(binaryData, invoice.fileName);
    });
  }

  downloadFile(bytes: BlobPart[], fileName: string) {
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob(bytes, { type: 'blob' }));
    downloadLink.setAttribute('download', fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

}
